import { SmepEventOnCallPerson } from '@nativewaves/nw-cloud-sdk/smep'

/**
 * What to call an on call person. Only the platform can put a name to a user id — identity refuses to
 * hand one user another's profile — so an unresolved person falls back to the email it did resolve,
 * and keeps their place under the raw id rather than disappearing from the escalation order.
 */
export const onCallPersonLabel = (person: SmepEventOnCallPerson) => person.name || person.email || person.userId
